/* Simple Brand — theme behavior
   AJAX cart, countdown timers, product variant picker, mobile nav,
   announcement bar dismiss. No framework, no build step. */
(function () {
  'use strict';

  /* ---------------- Announcement bar ---------------- */
  function initAnnouncement() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    var key = 'sb-announcement-dismissed-' + (bar.dataset.id || '');
    if (sessionStorage.getItem(key)) { bar.hidden = true; return; }
    var closeBtn = bar.querySelector('[data-announcement-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        sessionStorage.setItem(key, '1');
      });
    }
  }

  /* ---------------- Mobile nav ---------------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var panel = document.querySelector('[data-mobile-nav]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = panel.hasAttribute('data-open');
      if (open) {
        panel.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        panel.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ---------------- Countdown timers ----------------
     Any element with [data-countdown="ISO-8601 datetime"] gets
     child nodes [data-cd-days] [data-cd-hours] [data-cd-mins] [data-cd-secs]
     populated and refreshed every second. */
  function initCountdowns() {
    var nodes = document.querySelectorAll('[data-countdown]');
    if (!nodes.length) return;

    function tick() {
      nodes.forEach(function (el) {
        var target = new Date(el.getAttribute('data-countdown')).getTime();
        if (isNaN(target)) return;
        var now = Date.now();
        var diff = Math.max(0, target - now);

        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);

        setText(el.querySelector('[data-cd-days]'), pad(days, days > 99 ? 3 : 2));
        setText(el.querySelector('[data-cd-hours]'), pad(hours));
        setText(el.querySelector('[data-cd-mins]'), pad(mins));
        setText(el.querySelector('[data-cd-secs]'), pad(secs));

        if (diff <= 0) {
          el.setAttribute('data-countdown-complete', '');
          var liveMsg = el.querySelector('[data-cd-complete-msg]');
          if (liveMsg) liveMsg.hidden = false;
        }
      });
    }

    function pad(n, len) {
      len = len || 2;
      return String(n).padStart(len, '0');
    }
    function setText(node, val) {
      if (node) node.textContent = val;
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ---------------- Password page gate toggle ---------------- */
  function initPasswordToggle() {
    var link = document.querySelector('[data-pw-toggle]');
    var form = document.querySelector('[data-pw-form]');
    if (!link || !form) return;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var open = form.hasAttribute('data-open');
      if (open) {
        form.removeAttribute('data-open');
      } else {
        form.setAttribute('data-open', '');
        var input = form.querySelector('input[type="password"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------------- Password page early-access signup (AJAX) ---------------- */
  function initEarlyAccessForm() {
    var wraps = document.querySelectorAll('[data-early-access-wrap]');
    wraps.forEach(function (wrap) {
      var form = wrap.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        fetch(form.action, { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
          .then(function () {
            var success = wrap.querySelector('[data-early-access-success]');
            form.reset();
            form.hidden = true;
            if (success) success.setAttribute('data-show', '');
          })
          .catch(function () {
            form.submit();
          });
      });
    });
  }

  /* ---------------- Cart (AJAX) ---------------- */
  var Cart = {
    overlay: null,
    drawer: null,

    init: function () {
      this.overlay = document.querySelector('[data-cart-overlay]');
      this.drawer = document.querySelector('[data-cart-drawer]');
      if (!this.drawer) return;

      document.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('submit', this.onSubmit.bind(this));
      document.addEventListener('change', this.onChange.bind(this));

      this.refresh();
    },

    open: function () {
      if (this.overlay) this.overlay.setAttribute('data-open', '');
      if (this.drawer) this.drawer.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      if (this.overlay) this.overlay.removeAttribute('data-open');
      if (this.drawer) this.drawer.removeAttribute('data-open');
      document.body.style.overflow = '';
    },

    onClick: function (e) {
      if (e.target.closest('[data-cart-open]')) {
        e.preventDefault();
        this.open();
      }
      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        this.close();
      }
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        this.changeLine(removeBtn.getAttribute('data-cart-remove'), 0);
      }
      var stepBtn = e.target.closest('[data-cart-step]');
      if (stepBtn) {
        e.preventDefault();
        var wrap = stepBtn.closest('[data-cart-qty-wrap]');
        var input = wrap.querySelector('input');
        var qty = parseInt(input.value, 10) || 1;
        qty += stepBtn.getAttribute('data-cart-step') === 'up' ? 1 : -1;
        if (qty < 1) qty = 0;
        this.changeLine(wrap.getAttribute('data-cart-qty-wrap'), qty);
      }
      var quickAdd = e.target.closest('[data-quick-add]');
      if (quickAdd) {
        e.preventDefault();
        this.addVariant(quickAdd.getAttribute('data-quick-add'), quickAdd);
      }
    },

    onChange: function (e) {
      var input = e.target.closest('[data-cart-qty-input]');
      if (input) {
        var wrap = input.closest('[data-cart-qty-wrap]');
        var qty = parseInt(input.value, 10) || 0;
        this.changeLine(wrap.getAttribute('data-cart-qty-wrap'), qty);
      }
    },

    onSubmit: function (e) {
      var form = e.target.closest('form[data-add-to-cart-form]');
      if (!form) return;
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      var formData = new FormData(form);
      var body = { items: [{ id: formData.get('id'), quantity: parseInt(formData.get('quantity') || '1', 10) }] };
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.label = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.label; }
          if (res.status) throw new Error(res.description || 'Could not add to cart');
          Cart.refresh();
          Cart.open();
        })
        .catch(function (err) {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.label; }
          console.error('[Simple Brand] add to cart failed', err);
          alert(err.message || 'Sold out or unavailable.');
        });
    },

    addVariant: function (variantId, btn) {
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          btn.textContent = original;
          if (res.status) throw new Error(res.description || 'Could not add to cart');
          Cart.refresh();
          Cart.open();
        })
        .catch(function (err) {
          btn.textContent = original;
          alert(err.message || 'Sold out or unavailable.');
        });
    },

    changeLine: function (key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { Cart.refresh(); });
    },

    refresh: function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.render(cart); });
    },

    render: function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
        el.textContent = formatMoney(cart.total_price);
      });

      var itemsEl = this.drawer && this.drawer.querySelector('[data-cart-items]');
      if (!itemsEl) return;

      if (!cart.items.length) {
        itemsEl.innerHTML = '<p class="sb-cart-empty label-xs">Your bag is empty</p>';
        return;
      }

      itemsEl.innerHTML = cart.items.map(function (item) {
        var img = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_160x$1$2') : '';
        return (
          '<div class="sb-cart-line">' +
            (img ? '<img src="' + img + '" alt="" width="80" height="100" loading="lazy">' : '') +
            '<div style="flex:1">' +
              '<p class="sb-cart-line__title">' + escapeHtml(item.product_title) + '</p>' +
              (item.variant_title ? '<p class="sb-cart-line__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
              '<div class="sb-cart-line__row">' +
                '<div class="sb-qty" data-cart-qty-wrap="' + item.key + '">' +
                  '<button type="button" data-cart-step="down" aria-label="Decrease quantity">−</button>' +
                  '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-cart-qty-input aria-label="Quantity">' +
                  '<button type="button" data-cart-step="up" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<span class="label-xs">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
              '<button type="button" class="sb-cart-line__remove" data-cart-remove="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }
  };

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + amount;
    }
  }

  /* ---------------- Product variant picker ---------------- */
  function initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (root) {
      var variantsJson = root.querySelector('[data-variants-json]');
      if (!variantsJson) return;
      var variants;
      try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }

      var optionInputs = root.querySelectorAll('[data-option-index]');
      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-product-price]');
      var compareEl = root.querySelector('[data-product-compare-price]');
      var submitBtn = root.querySelector('[data-add-to-cart]');
      var mobileSubmitBtn = document.querySelector('[data-add-to-cart-mobile]');

      function currentSelection() {
        var selected = [];
        optionInputs.forEach(function (group) {
          var active = group.querySelector('[data-selected]');
          selected[parseInt(group.getAttribute('data-option-index'), 10)] = active ? active.getAttribute('data-value') : null;
        });
        return selected;
      }

      function findVariant() {
        var selected = currentSelection();
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }

      function updateUI() {
        var variant = findVariant();
        [submitBtn, mobileSubmitBtn].forEach(function (btn) {
          if (!btn) return;
          if (!variant) {
            btn.disabled = true;
            btn.textContent = 'Unavailable';
          } else if (!variant.available) {
            btn.disabled = true;
            btn.textContent = 'Sold out';
          } else {
            btn.disabled = false;
            btn.textContent = (btn.getAttribute('data-label') || 'Add to bag') + ' — ' + formatMoney(variant.price);
          }
        });
        if (variant && idInput) idInput.value = variant.id;
        if (variant && priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
      }

      root.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-value]');
        if (!opt || opt.disabled) return;
        var group = opt.closest('[data-option-index]');
        group.querySelectorAll('[data-value]').forEach(function (b) { b.removeAttribute('data-selected'); });
        opt.setAttribute('data-selected', '');
        var label = group.querySelector('[data-option-selected-label]');
        if (label) label.textContent = opt.getAttribute('data-value');
        updateUI();
      });

      updateUI();
    });
  }

  /* ---------------- Mobile sticky buy bar ---------------- */
  function initMobileBuyBar() {
    var btn = document.querySelector('[data-add-to-cart-mobile]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var form = document.querySelector('form[data-add-to-cart-form]');
      if (form) form.requestSubmit();
    });
  }

  /* ---------------- Product gallery ---------------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var mains = gallery.querySelectorAll('[data-gallery-main]');
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.removeAttribute('data-active'); });
          mains.forEach(function (m) { m.removeAttribute('data-active'); });
          thumb.setAttribute('data-active', '');
          if (mains[i]) mains[i].setAttribute('data-active', '');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initMobileNav();
    initCountdowns();
    initPasswordToggle();
    initEarlyAccessForm();
    Cart.init();
    initProductForms();
    initGallery();
    initMobileBuyBar();
  });
})();
